import React, { useState } from "react";
import { useEffect } from "react";
import { Accordion } from "react-bootstrap-accordion";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import WOW from "wowjs";
import { Icon } from "@iconify/react";
import ClientLogo from "../../Shared/ClientLogo";
import { Helmet } from "react-helmet-async";

const DigitalMarketingServices = (props) => {
  const [activeTab, setActiveTab] = useState(0);
  const [watchReel, setWatchReel] = useState(false);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  useEffect(() => {
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
  }, []);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };


  return (
    <>
      <Helmet>
        <title>Best SEO Agency in Malad, Mumbai - Digital Marketing Service</title>
        <meta name="description" content="Discover the Best SEO Agency in Malad, Mumbai with Reverse Thought Creative Studio. Our proven Digital Marketing Services promote higher rankings, organic traffic, and help your business grow online with consistent results." />
        
        <meta name="robots" content="max-image-preview:large" />
        <meta name="google-site-verification" content="HoCjksaLBwM7qPH8Nt-Rzrqa5K02wXYiJwFSEMC4j8g" />
        <meta name="p:domain_verify" content="f307b6f44d53f755ef67d9a9a3666de7" />
        <meta name="keywords" content="Best SEO Agency in Malad, Best SEO Agency in Mumbai, SEO Company in Malad, Digital Marketing Service in Malad " />
        <link rel="canonical" href="https://www.reversethought.com/digital-marketing/" />

        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content="Reverse Thought" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Best SEO Agency in Malad, Mumbai - Digital Marketing Service" />
        <meta property="og:description" content="Discover the Best SEO Agency in Malad, Mumbai with Reverse Thought Creative Studio. Our proven Digital Marketing Services promote higher rankings, organic traffic, and help your business grow online with consistent results." />
        <meta property="og:url" content="https://www.reversethought.com/digital-marketing" />

        <meta property="article:tag" content="best seo agency in Malad" />
        <meta property="article:tag" content="best seo agency in Mumbai" />
        
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@rthoughtindia" />
        <meta name="twitter:title" content="Best SEO Agency in Malad, Mumbai - Digital Marketing Service" />
        <meta name="twitter:description" content="Discover the Best SEO Agency in Malad, Mumbai with Reverse Thought Creative Studio. Our proven Digital Marketing Services promote higher rankings, organic traffic, and help your business grow online with consistent results." />
        <meta name="google" content="nositelinkssearchbox" />
       
      </Helmet>
      {/* <h1 className="d-none">Digital Marketing Services Mumbai</h1>
      <h2 className="d-none">digital advertising agencies in mumbai</h2>
      <h2 className="d-none">Best Digital Marketing Agency In Mumbai</h2> */}
      
      <section className="servicePageSection webServicePageSection digitalservices position-relative">
        <div className="content_container position-relative">
          <img
            src="/images/digital-services.png"
            alt="SEO Agency in Malad"
            className="digitalservicesVector"
          />
          <div className="servicePageBanner">
            <h3 className="colorBlack fw-800 projectHeading wow animate__animated animate__fadeInUp">
              Boost Your Online <br />
              Presence Today!
            </h3>

            <h4 className="serviceKeyPoints colorBlack fw-800 wow animate__animated animate__fadeInUp animation_delay_100ms">
              Optimize.
            </h4>
            <h4 className="serviceKeyPoints colorBlack fw-800 wow animate__animated animate__fadeInUp animation_delay_200ms">
              Engage.
            </h4>
            <h4 className="serviceKeyPoints colorBlue fw-800 wow animate__animated animate__fadeInUp animation_delay_300ms">
              Dominate.
            </h4>
          </div>
        </div>
      </section>
      <section className="webServiceWhatWeDo whatWeDo">
        <div className="content_container">
          <h1 className="sectionHead colorBlack fw-800 wow">
            <img src="/images/icons/line.svg" alt="line" />
           Our Digital Marketing & SEO Services
          </h1>
          <div className="row m-0 whatwedoTabs">
            <div className="col-sm-6 p-0 whatwedoTabsL wow animate__animated animate__fadeInUp">
              <ul>
                <li
                  onClick={() => handleTabClick(0)}
                  className={
                    activeTab === 0
                      ? "wow animate__animated animate__fadeInUp active"
                      : "wow animate__animated animate__fadeInUp"
                  }
                >
                  SEM /SEO
                </li>
                <li
                  onClick={() => handleTabClick(1)}
                  className={
                    activeTab === 1
                      ? "wow animate__animated animate__fadeInUp active"
                      : "wow animate__animated animate__fadeInUp"
                  }
                >
                  PPC / PPM Campaigns
                </li>
                <li
                  onClick={() => handleTabClick(2)}
                  className={
                    activeTab === 2
                      ? "wow animate__animated animate__fadeInUp active"
                      : "wow animate__animated animate__fadeInUp"
                  }
                >
                  Email & Blog Marketing
                </li>
                <li
                  onClick={() => handleTabClick(3)}
                  className={
                    activeTab === 3
                      ? "wow animate__animated animate__fadeInUp active"
                      : "wow animate__animated animate__fadeInUp"
                  }
                >
                  Whatsapp Campaign
                </li>
              </ul>
            </div>
            <div className="col-sm-6 p-0 whatwedoTabsR wow animate__animated animate__fadeInUp animation_delay_300ms">
              {activeTab === 0 && (
                <div
                  className={
                    activeTab === 0
                      ? "whatWeDoTabsResult wow animate__animated animate__fadeInLeft"
                      : "whatWeDoTabsResult"
                  }
                >
                  <p className="colorBlack fw-400">
                    Boost your online presence with our expert search engine
                    marketing (SEM) and search engine optimization (SEO)
                    services. We ensure your website ranks high on Google and
                    other search engines, driving increased traffic and leads
                    through targeted campaigns and comprehensive optimization
                    techniques.
                  </p>
                  <a
                    href="/works/digital-marketing"
                    className="unsetAll"
                    // onClick={() => window.scrollTo(0, 0)}
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    <span className="commonViewAll linksYw_hover colorBlue">Learn More</span>
                    <Icon icon="clarity:arrow-line" />
                  </a>
                </div>
              )}
              {activeTab === 1 && (
                <div
                  className={
                    activeTab === 1
                      ? "whatWeDoTabsResult wow animate__animated animate__fadeInLeft"
                      : "whatWeDoTabsResult"
                  }
                >
                  <p className="colorBlack fw-400">
                    We specialise in running online campaigns that are aimed to
                    maximise your ROI. From bidding for the right keywords,
                    detailed audience segmentation, experimentation and
                    adaptation- we do it all to ensure relevant and quality
                    traffic to your site or app that has enough reason to
                    convert into a lead.
                  </p>
                  <a
                    href="/works/digital-marketing"
                    className="unsetAll"
                    // onClick={() => window.scrollTo(0, 0)}
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    <span className="commonViewAll linksYw_hover colorBlue">Learn More</span>
                    <Icon icon="clarity:arrow-line" />
                  </a>
                </div>
              )}
              {activeTab === 2 && (
                <div
                  className={
                    activeTab === 2
                      ? "whatWeDoTabsResult wow animate__animated animate__fadeInLeft"
                      : "whatWeDoTabsResult"
                  }
                >
                  <p className="colorBlack fw-400">
                    Let us use our content creation skills to leverage your
                    domain expertise as a business-building tool. Through
                    thoughtfully written, insightful blogs, articles and
                    emailers, be viewed as an authority in your field, gain
                    customer confidence and build your business. As a plus, your
                    Search rankings will also take a leap.
                  </p>
                  <a
                    href="/works/digital-marketing"
                    className="unsetAll"
                    // onClick={() => window.scrollTo(0, 0)}
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    <span className="commonViewAll linksYw_hover colorBlue">Learn More</span>
                    <Icon icon="clarity:arrow-line" />
                  </a>
                </div>
              )}
              {activeTab === 3 && (
                <div
                  className={
                    activeTab === 3
                      ? "whatWeDoTabsResult wow animate__animated animate__fadeInLeft"
                      : "whatWeDoTabsResult"
                  }
                >
                  <p className="colorBlack fw-400">
                    Using inbound marketing strategies that include reaching
                    people on social media, connecting with them through
                    interesting, thought-provoking articles and blogs,
                    organising webinars and using a wide range of techniques, we
                    help you build leads. Going a step further, we can also help
                    you nurture them through various means.
                  </p>
                  <a
                    href="/works/digital-marketing"
                    className="unsetAll"
                    // onClick={() => window.scrollTo(0, 0)}
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    <span className="commonViewAll linksYw_hover colorBlue">Learn More</span>
                    <Icon icon="clarity:arrow-line" />
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <section className="ourWorkSlider ourWorkslider2 wow animate__animated animate__slideInLeft">
        <div className="content_container">
          <h3 className="sectionHead text-dark colorBlack fw-800 wow ">
            <img src="/images/icons/line.svg" alt="line" />
            Digital Marketing Work
          </h3>
          <Slider {...settings}>
            <div>
              <div className="sliderInner">
              <a href="/mpuh" className="text-decoration-none">
                <div className="imgHoverEffect position-relative">
                  <a
                    href="/mpuh"
                    className="colorWhite fw-800"
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    View Projects &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="toparrow"
                      className="img-fluid"
                    />
                  </a>
                  <img src="/images/cards/digital/mpuh.jpg" alt="work" />
                </div>
                <h3 className="colorBlack fw-800 pt-3">MPUH</h3>
                <span className="colorGrey fw-400">Digital Marketing</span>
                </a>
              </div>
            </div>
            <div>
              <div className="sliderInner">
              <a href="/speak-health2" className="text-decoration-none">
                <div className="imgHoverEffect position-relative">
                  <a
                    href="/speak-health2"
                    className="colorWhite fw-800"
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    View Projects &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="toparrow"
                      className="img-fluid"
                    />
                  </a>
                  <img src="/images/cards/digital/sh.jpg" alt="work" />
                </div>
                <h3 className="colorBlack fw-800 pt-3">Speak Health</h3>
                <span className="colorGrey fw-400">Digital Marketing</span>
                </a>
              </div>
            </div>
            <div>
              <div className="sliderInner">
              <a href="/sky-greens" className="text-decoration-none">
                <div className="imgHoverEffect position-relative">
                  <a
                    href="/sky-greens"
                    className="colorWhite fw-800"
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    View Projects &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="toparrow"
                      className="img-fluid"
                    />
                  </a>
                  <img src="/images/cards/digital/skygreens.jpg" alt="work" />
                </div>
                <h3 className="colorBlack fw-800 pt-3">Skygreens</h3>
                <span className="colorGrey fw-400">Digital Marketing</span>
                </a>
              </div>
            </div>
            <div>
              <div className="sliderInner">
              <a href="/speed-of-sound" className="text-decoration-none">
                <div className="imgHoverEffect position-relative">
                  <a
                    href="/speed-of-sound"
                    className="colorWhite fw-800"
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    View Projects &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="toparrow"
                      className="img-fluid"
                    />
                  </a>
                  <img src="/images/cards/digital/sos.jpg" alt="work" />
                </div>
                <h3 className="colorBlack fw-800 pt-3">Speed Of Sound</h3>
                <span className="colorGrey fw-400">Digital Marketing</span>
                </a>
              </div>
            </div>
          </Slider>
          <Link
            to="/works/digital-marketing"
            className="unsetAll"
            onClick={() => window.scrollTo(0, 0)}
            onMouseEnter={props.onMouseEnterSmall}
            onMouseLeave={props.onMouseLeaveSmall}
          >
            <span className="commonViewAll colorBlue linksYw_hover">View Our Projects</span>
            <Icon icon="clarity:arrow-line" />
          </Link>
        </div>
      </section>{" "}
      <section
        className="ourExpertiseSection wow animate__animated animate__slideInUp"
        onMouseEnter={props.mouseEnterOnBlack}
        onMouseLeave={props.mouseLeaveOnBlack}
      >
        <div className="content_container">
          <h3 className="sectionHead text-white colorWhite fw-800 wow">
            <img src="/images/icons/line-white.svg" alt="line" />
            Our Expertise
          </h3>
          <div className="row">
          <div className="col-sm-6 accordianParent wow animate__animated animate__fadeIn animation_delay_300ms">
            <Accordion title="Search Engine Marketing (SEM)">
              <p>
                Fast-track your success with compelling search ads. Our
                meticulously managed campaigns have driven businesses to the
                top, delivering a surge in traffic and quality leads.
              </p>
            </Accordion>
            <Accordion title="Search Engine Optimization (SEO)">
              <p>
                Unlock global visibility with Google as the paramount search
                engine worldwide, excluding China. Ensure prime first-page
                rankings for your business-critical keywords. SEO, although
                gradual, wields undeniable power, making it an essential
                strategy. Our arsenal includes on-page & off-page wizardry,
                enriched content & compelling blogs, strategic directory
                listings, potent backlinks, and a myriad of tactics that propel
                your website skyward in search rankings.
              </p>
            </Accordion>
            <Accordion title="PPC / PPM Campaigns">
              <p>
                Our expertise lies in orchestrating online campaigns with one
                clear goal: to optimise your return on investment (ROI). Whether
                it's strategic keyword bidding, precise audience segmentation,
                iterative experimentation, or seamless adaptation, we execute
                every step. The result? Driving valuable, conversion-ready
                traffic to your website or app, ensuring a compelling incentive
                for lead generation.
              </p>
            </Accordion></div>
            <div className="col-sm-6 accordianParent wow animate__animated animate__fadeIn animation_delay_300ms">
            <Accordion title="Video Advertising & Marketing">
              <p>
                Here's a YouTube insight: when your video gains substantial
                views within its first hour, YouTube boosts its visibility.
                Elevate your video success by securing a strong viewership
                during that crucial first hour. Additionally, we specialise in
                expanding the reach of your older videos, ensuring they resonate
                with a broader audience over time.
              </p>
            </Accordion>
            <Accordion title="Media Buying">
              <p>
                Our team of experts engages with you to understand your target
                audience and carefully identifies the right media plan for you.
                Our bulk buying helps get you good deals and more value for your
                dollars.
              </p>
            </Accordion>
            {/* <Accordion title="Campaign Microsites">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur.
              </p>
            </Accordion>
            <Accordion title="Lead Generation & Nurturing">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur.
              </p>
            </Accordion>
            <Accordion title="Lorem ipsum">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur.
              </p>
            </Accordion>
            <Accordion title="Lorem ipsum">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur.
              </p>
            </Accordion> */}
          </div>
          </div>
          <h3 className="sectionHead colorWhite text-white fw-800 wow">
            <img src="/images/icons/line-white.svg" alt="line" />
            Why Choose Us
          </h3>
          <div className="whyChooseUsDetails">
            <p className="colorWhite fw-400 wow animate__animated animate__fadeInUp">
              In the realm of digital marketing, we've consistently pushed the
              limits and defied conventions to connect your goals with the
              desires of your target audience. Our digital marketing expertise
              combines interactive strategies, compelling content, engaging
              visuals, and user-friendly interfaces, seamlessly integrated with
              state-of-the-art technologies including advanced analytics,
              AI-driven marketing tools, social media platforms, and more, to
              create immersive and captivating online experiences.
            </p>
            <ul className="d-flex align-items-center wow animate__animated animate__fadeInUp animation_delay_300ms">
              <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                Data Analytics and Insights
              </li>
              <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                Search Engine Optimization (SEO)
              </li>
              <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                Whatsapp Campaign
              </li>
              <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                Email Marketing Automation
              </li>
              <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                E-commerce Platforms
              </li>
              <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                Conversion Rate Optimization
              </li>
              <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                Pay-Per-Click (PPC) Advertising
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="webServicePageClient ourRecentClients">
        <div className="content_container">
          <h3 className="sectionHead colorBlack fw-800 wow">
            <img src="/images/icons/line.svg" alt="line" />
            Our Recent Clients
          </h3>
          <ClientLogo client="digiMarketClient" />
        </div>
      </section>
      <section className="pt-0 creativeThoughts position-relative">
        <div className="content_container">
          <img
            src="/images/icons/circle-l.png"
            alt="circle-l"
            className="wow animate__animated animate__rotateIn"
          />

          <div className="colorBlack fw-800 company">
            <p className="mb-0 wow">We strive to elevate your </p>
            <p className="mb-0 wow">brand's online presence and</p>
            <p className="mb-0 wow">boost your bottom line.</p>
          </div>
          <div className="text-end">
            <img
              src="/images/icons/circle-r.png"
              alt="circle-r"
              className="wow animate__animated animate__rotateIn"
            />
          </div>
        </div>
      </section>

      {/* <section style={{//backgroundColor:"black", color:"white"}}>
        <div className="content_container">             
          <div className="accordianParent wow animate__animated animate__fadeIn animation_delay_300ms">
            <Accordion title="RT">
            
            </Accordion>
          </div>
        </div>
      </section> */}


      <section className="aboitUsSection clientsMainSection position-relative">
        <div className="content_container">
          <div className="servicePageBanner">
            {/* <h2 className="colorBlack fw-800 projectHeading wow animate__animated animate__fadeInUp" style={{fontSize: "50px", lineHeight: "normal"}}>
            Boost Your Brand with Reverse Thought - Top Digital Agency in Mumbai
            </h2> */}
            <p className="colorBlack fw-400 projectDesc wow animate__animated animate__fadeInUp animation_delay_300ms pt-1" style={{fontSize: "16px", letterSpacing: "normal", lineHeight: "20px"}}>Looking for digital advertising agencies in Mumbai? Reverse thought is the Best Digital Marketing Agency In Mumbai! We are here to build brands in the digital realm.</p>
            <p className="colorBlack fw-400 projectDesc wow animate__animated animate__fadeInUp animation_delay_300ms pt-1" style={{fontSize: "16px", letterSpacing: "normal", lineHeight: "20px"}}>We provide end to end Digital Marketing Services in Mumbai including SEM/SEO, PPC / PPM Campaigns, PPC / PPM Campaigns and Whatsapp Campaign. Our expert team specializes in crafting tailor-made strategies to meet the market demand.</p>
            <p className="colorBlack fw-400 projectDesc wow animate__animated animate__fadeInUp animation_delay_300ms pt-1" style={{fontSize: "16px", letterSpacing: "normal", lineHeight: "20px"}}>Our comprehensive solutions can skyrocket your digital visibility. With the latest tools and techniques, we deliver exceptional results. Rest assured that you will receive proactive and results-driven approaches.</p>
            <p className="colorBlack fw-400 projectDesc wow animate__animated animate__fadeInUp animation_delay_300ms pt-1" style={{fontSize: "16px", letterSpacing: "normal", lineHeight: "20px"}}>At Reverse thought, we understand your unique business goals. We work closely with our valued clients to develop strategies that meet your target. With our digital agency in Mumbai by your side, you will experience improved brand awareness.</p>
          </div>
        </div>
      </section>

    </>
  );
};

export default DigitalMarketingServices;
